<template>
  <div class="movie-progress-bar no-swipe-nav">
    <div class="movie-progress-bar__timeline" @click="seek">
      <div class="movie-progress-bar__progress" :style="'width:' + progressPercentage + '%'"></div>
    </div>
    <div class="movie-progress-bar__dot" @mouseown="mouseDown" @mouseup="mouseUp" @mousemove="mouseMove" :style="'left:' + progressPercentage + '%'"></div>
  </div>
</template>

<script>
export default {
  name: 'movie-progress-bar',
  props: ['progress'],
  data() {
    return {
      progressPercentage: 0,
      isMouseDown: false,
      dot: null,
    };
  },
  mounted() {
    this.$el.addEventListener('mouseup', this.mouseUp);
    this.$el.addEventListener('mouseleave', this.mouseLeave);
    this.$el.addEventListener('mousedown', this.mouseDown);
    this.$el.addEventListener('mousemove', this.mouseMove);
    this.$el.addEventListener('touchmove', this.touchMove);
  },
  methods: {
    width() {
      return this.$el.offsetWidth;
    },
    left() {
      return this.$el.getBoundingClientRect().left;
    },
    seek(event) {
      const percentage = ((event.clientX - this.left()) / this.width());
      this.$emit('change', percentage);
      this.progressPercentage = percentage * 100;
    },
    mouseDown() {
      this.isMouseDown = true;
    },
    mouseUp() {
      this.isMouseDown = false;
    },
    mouseLeave() {
      this.isMouseDown = false;
    },
    mouseMove(event) {
      if (this.isMouseDown) {
        const percentage = ((event.clientX - this.left()) / this.width());
        this.$emit('change', percentage);
        this.progressPercentage = percentage * 100;
      }
    },
    touchMove(event) {
      this.emitPercentage(event.touches[0].clientX);
    },
  },
  watch: {
    progress() {
      this.progressPercentage = this.progress * 100;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/helpers';

.movie-progress-bar {
  display: block;
  width: calc(100% - 80px);
  margin: 100px 40px 30px;
  padding: 15px 0;
  position: absolute;
  bottom: 0;
  z-index: 1;
  transition: opacity .3s;

  &.hidden {
    opacity: 0;
  }

  &__timeline {
    width: 100%;
    height: 10px;
    border-radius: 5px;
    position: relative;
    overflow: hidden;
    background: $c_white;
  }

  &__progress {
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: $c_primary;
    transition: width .15s;
  }

  &__dot {
    width: 22px;
    height: 22px;
    margin: -6px;
    transform: translateX(-5px);
    top: 15px;
    border-radius: 11px;
    background: $c_primary;
    box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.16);
    transition: left .15s;
    position: absolute;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MovieProgressBar.vue